(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pango-carta-enlaces"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.p-carta-enlaces p').forEach(el => {
    el.addEventListener('click', () => {  
      addBorderSelectedLink(el)
      const enlaceId = el.dataset.enlaceId;
      showMenuSection(enlaceId);
    });
  });
  
  function showMenuSection(enlaceId) {
    const targetElements = document.querySelectorAll(`[data-id="${enlaceId}"]`);
  
    if (targetElements.length > 0) {
      document.querySelectorAll('.p-carta').forEach(section => {
        section.classList.remove('p-active');
      });
      targetElements.forEach(target => {
        target.classList.add('p-active');
      });
    }
  }

  function addBorderSelectedLink(el){
    document.querySelectorAll('.p-carta-enlaces p').forEach(enlace => enlace.classList.remove('p-borde-activo'));
    el.classList.add('p-borde-activo');
  }

// logica popup

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("p-popup");
  const popupImg = document.getElementById("popup-img");
  const popupName = document.getElementById("popup-name");
  const closeBtn = document.querySelector(".p-close-btn");
  const popupButtons = document.querySelectorAll(".p-popup-btn");

  // Lógica del popup 
  function closePopup() {
    popup.style.display = "none";
    popupImg.src = "";
    popupName.textContent = "";
    document.body.classList.remove("popup-abierto");
  }

  popupButtons.forEach(button => {
    button.addEventListener("click", function () {
      const imgUrl = this.getAttribute("data-img");
      const productName = this.getAttribute("data-name");
      popupImg.src = imgUrl;
      popupName.textContent = productName.toUpperCase()
      popup.style.display = "flex";
      document.body.classList.add("popup-abierto");
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closePopup();
    });
  }

  popup.addEventListener("click", function (e) {
    const content = popup.querySelector('.p-popup-content');
    if (!content.contains(e.target)) {
      closePopup();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
